import PersonIcon from '@mui/icons-material/Person';
// import ClientCreate from './ClientCreate';
// import ClientEdit from './ClientEdit';
import ClientShow from './ClientShow';
import { ClientsList } from './ClientsList';

const clients = {
  list: ClientsList,
  // create: ClientCreate,
  // edit: ClientEdit,
  show: ClientShow,
  icon: PersonIcon,
};

export default clients;
